export const features = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '极速爆料',
    desc: '7×24小时全天候监控娱乐圈动态，重大爆料5分钟内上线，比热搜快一步，让你永远在吃瓜第一线。',
  },
  {
    id: 2,
    icon: 'ri-search-eye-line',
    title: '深度追踪',
    desc: '不只告诉你发生了什么，更带你挖出背后的来龙去脉。每条爆料的因果链、人物关系全梳理。',
  },
  {
    id: 3,
    icon: 'ri-group-line',
    title: '瓜友社区',
    desc: '百万瓜友在线讨论，神评论比瓜还精彩。理性吃瓜，文明讨论，一起做有态度的吃瓜群众。',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '权威核实',
    desc: '每条信息必经多方交叉验证，标注信息可信度等级。不传谣、不造谣，做负责任的娱乐资讯平台。',
  },
  {
    id: 5,
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: 'PC、手机、平板无缝切换，推送提醒不错过任何一个大瓜。支持离线阅读，地铁上也能畅快吃瓜。',
  },
];